/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import snackbarOpen from '../../store/action-creators/snackbarActionCreators';
import { fetchUserDashboardConversations } from '../../store/actions/conversationActions';
import { CONVERSATION_CONTROL_TABS, SNACKBAR } from '../../utils/constants'
import { simpleGTMDataLayer } from '../../utils/utilities';
import DashBoardConversations from '../dashBoardConversations/DashBoardConversations'

const Container = styled.div`
    margin:15px 25px 0;
`;

export default function MyConversations() {
    const [isLoading, setLoading] = useState(false);
    const [conversations, setConversations] = useState<any>([]);
    const [isfilter, setFilter] = useState<boolean>(false);
    const [isSort, setSortFlag] = useState<boolean>(true);
    const [filterDD, setFilterDD] = useState<string>('Display Range');
    const [count, setCount] = useState(0);
    const [page, setPage] = useState(0);
    const [date, setDate] = useState(undefined);
    const user = useSelector((state: any) => state.user);
    const dispatch = useDispatch();
    const selectedAdjuster = {
        adjusterName: user.fullName,
        adjusterEmailId: user.email
    }
  //  let filterdate: any = undefined;

    useEffect(() => {
        simpleGTMDataLayer({
            csrId: user.userName,
            event: 'pageview',
            page: {
                path: '/conversation-control',
                title: 'Claims Texting: My Conversations Page'
            }
        });
    }, []);

    useEffect(() => {
       // if(date!==undefined)
        fetchMyConversations();
    }, [page,isSort]);

    useEffect(() => {
        if(date!==undefined)
        fetchMyConversations();
    }, [date])


    useEffect(() => {
        if (isfilter === false)
            fetchMyConversations();
    }, [isfilter])


    const fetchMyConversations = () => {
        setLoading(true);
        // if (conversations.length >= page * 2 + 2 || (conversations.length === count && count !== 0 && isfilter !== true)) {
        //     setLoading(false);
        //     return;
        // }
        fetchUserDashboardConversations({ adjusterId: user.email, index: page, limit: 100, filter: isfilter, date: date, sortFlag:isSort }, (res: any) => {
            //setConversations([...conversations,...res.myConversations]);
            setConversations([...res.myConversations]);
            setCount(res.count);
            setLoading(false);
        }, (error: any) => {
            dispatch(snackbarOpen({ open: true, message: error.message, type: SNACKBAR.ERROR }))
            setLoading(false);
        });
    }

    const updatePage = (page: any) => {
        setPage(page);
    }

    const setConversationsEmpty = () => {
        setConversations([]);
        setPage(0);
        setCount(0);
        setDate(undefined);
        setSortFlag(true);
    }

    const getFilterData = (value: any) => {
       // filterdate = value;
        setDate(value);
       // fetchMyConversations();
    }

    return (
        <Container data-testid="my-conversations">
            {isLoading ?
                <div className="loader" /> :
                <DashBoardConversations
                    selectedAdjuster={selectedAdjuster}
                    conversations={conversations}//.slice(page * 2, page * 2 + 2)}
                    fetchConversations={fetchMyConversations}
                    setConversations={setConversations}
                    totalCount={count}
                    page={page}
                    updatePage={updatePage}
                    setCount={setCount}
                    setConversationsEmpty={setConversationsEmpty}
                    selectedType={CONVERSATION_CONTROL_TABS.MYCONVERSATIONS}
                    getFilterInput={getFilterData}
                    isfilter={isfilter}
                    setFilter={setFilter}
                    filterDD={filterDD}
                    setFilterDD={setFilterDD}
                    sortFlag ={isSort}
                    setSortFlag ={setSortFlag}
                />}
        </Container>
    )
}
